import { lmnAssetsUiVersion } from '@lmn/lmn-ui-ancillaries-react';

export const assetsPath = 'https://assets.staticroot.com';
export const lmnAssetsPath = `${assetsPath}/lmn-assets-ui/${lmnAssetsUiVersion}`;
export const damAssetsPath = 'https://media.staticroot.com';
